import React from 'react'
import { Icon } from '../../atoms'
import { useEntity } from '../helpers/selectors'
import Image from '../imgix-img'
import classNames from 'classnames'
import dayjs from '../../utils/date'
import { EVEntry } from '../helpers/react'

export default (props) => {
  const {
    badgeTitle,
    badgeIcon,
    content,
    guideContent,
    sys,
    name,
    title,
    linkHref,
    variant = 'primary',
  } = props
  const contentEntity = useEntity(content)
  const guideHasImage = !!Object.keys(guideContent?.image ?? {}).length
  const componentTrackingObject = {
    component_category: 'card-v2',
    component_id: sys?.id,
    component_name: 'cardV2',
    contentful_name: name || title,
  }

  return (
    <div className={classNames('CardV2', `CardV2--${variant}`, { guide: guideContent })}>
      {(badgeTitle || badgeIcon) && (
        <div className='badge'>
          {badgeIcon && (
            <div className='badge__icon'>
              <Icon glyph={badgeIcon} size={32} />
            </div>
          )}
          {badgeTitle && <p className='badge__title'>{badgeTitle}</p>}
        </div>
      )}

      {guideHasImage && (
        <a
          href={linkHref}
          data-click-tracking={JSON.stringify({
            ...componentTrackingObject,
            ...{ link_path: linkHref },
            ...{ additionalProps: { text: guideContent.image.alt } },
          })}
        >
          <Image
            src={guideContent.image.url}
            alt={guideContent.image.alt}
            className='guide-image'
          />
        </a>
      )}

      {guideContent && (
        <div className='content'>
          <p className='date'>{dayjs(guideContent.updatedAtDate).format('DD MMMM YYYY')}</p>
          <h3>{guideContent.title}</h3>
          <p>{guideContent.description}</p>
          <a
            className='link'
            href={linkHref}
            data-click-tracking={JSON.stringify({
              ...componentTrackingObject,
              ...{ link_path: linkHref },
              ...{ additionalProps: { text: guideContent.linkText } },
            })}
          >
            {guideContent.linkText}
          </a>
        </div>
      )}

      {content && (
        <div className='content'>
          <EVEntry {...contentEntity} removeTopSpacing={true} removeBottomSpacing={true} />
        </div>
      )}
    </div>
  )
}
